export default {"src":"/_next/static/media/stay-burden-free.e71a60ff.svg","height":65,"width":64,"blurWidth":0,"blurHeight":0};